import { useTranslation } from 'react-i18next';
import IconBack from '../../../assets/Images/icons/icon-back';
import { ROUTER } from '../../../constants/router';
import { useNavigate } from 'react-router-dom';
import List from './components/List';
import Access from './components/Access';
import usePermission from './hooks/usePermission';
import { useState } from 'react';
import { Element } from 'react-scroll';

export default function Permissions() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { getPermissionList, permissionList } = usePermission();
    const [isEdit, setIsEdit] = useState(false);

    return (
        <Element id="main-permission">
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(ROUTER.CONFIGURATION.USER_MANAGEMENT)
                    }
                >
                    <IconBack />
                </button>
                {t('Permission')}
               
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('User Management')} /{' '}
                </span>
                <span> {t('Permission')}</span>
            </div>
            <div className="grid grid-cols-7 gap-4 my-4">
                <div className="bg-white col-span-2 rounded-lg h-max">
                    <List
                        getPermissionList={getPermissionList}
                        permissionList={permissionList}
                        setIsEdit={setIsEdit}
                        isEdit={isEdit}
                    />
                </div>
                <div className="bg-white col-span-5 rounded-lg h-max">
                    <Access
                        permissionList={permissionList}
                        getPermissionList={getPermissionList}
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                    />
                </div>
            </div>
        </Element>
    );
}
